import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const DeductMoney: FC<IIconsProps> = ({
  color,
  fillcolor,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  if (!fillcolor) {
    color = theme.palette.neutral['00'];
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9091 20.0002L20.3636 20.0002C21.4682 20.0002 22.3636 19.1048 22.3636 18.0002L22.3636 5.99998C22.3636 4.89541 21.4682 3.99998 20.3636 3.99998L12.9091 3.99998C11.8045 3.99998 10.9091 4.89541 10.9091 5.99998L10.9091 18.0002C10.9091 19.1048 11.8045 20.0002 12.9091 20.0002Z"
        fill={fillcolor}
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M15 16.783L15 16.889C15 17.1345 15.199 17.3335 15.4445 17.3335L17.8283 17.3335C18.0738 17.3335 18.2727 17.1345 18.2727 16.889L18.2727 16.783C18.2727 16.1052 18.8222 15.5557 19.5 15.5557C19.7259 15.5557 19.9091 15.3725 19.9091 15.1466L19.9091 8.85355C19.9091 8.62762 19.7259 8.44446 19.5 8.44446C18.8222 8.44446 18.2727 7.89499 18.2727 7.21719L18.2727 7.1111C18.2727 6.86564 18.0738 6.66665 17.8283 6.66665L15.4445 6.66665C15.199 6.66665 15 6.86564 15 7.1111L15 7.21719C15 7.89499 14.4505 8.44446 13.7727 8.44446C13.5468 8.44446 13.3636 8.62761 13.3636 8.85355L13.3636 15.1466C13.3636 15.3725 13.5468 15.5557 13.7727 15.5557C14.4505 15.5557 15 16.1052 15 16.783Z"
        stroke={color}
        strokeWidth="2"
      />
      <ellipse
        cx="16.6364"
        cy="12.0003"
        rx="0.888904"
        ry="0.818182"
        transform="rotate(-90 16.6364 12.0003)"
        fill={color}
      />
      <path
        d="M8 17L5.3624 12.9237C5.14297 12.5846 5.1491 12.1468 5.37793 11.8139L8 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4 17L1.3624 12.9237C1.14297 12.5846 1.1491 12.1468 1.37793 11.8139L4 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DeductMoney;
